import { useTranslation } from 'react-i18next';
import { CheckCircle2, Circle, Clock, LucideIcon } from 'lucide-react';
import { IssueStatus } from '@momentum/types';

export interface StatusConfig {
  icon: LucideIcon;
  label: string;
  className: string;
  iconColor: string;
  barColor: string;
}

export const useGoalStatus = (status: IssueStatus): StatusConfig => {
  const { t } = useTranslation('goals');

  const statusConfig = {
    [IssueStatus.COMPLETED]: {
      icon: CheckCircle2,
      label: t('statusCompleted'),
      className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      iconColor: 'text-emerald-600',
      barColor: 'bg-emerald-500',
    },
    [IssueStatus.IN_PROGRESS]: {
      icon: Clock,
      label: t('statusInProgress'),
      className: 'bg-blue-50 text-blue-700 border-blue-200',
      iconColor: 'text-blue-600',
      barColor: 'bg-blue-500',
    },
    [IssueStatus.TODO]: {
      icon: Circle,
      label: t('statusTodo'),
      className: 'bg-gray-50 text-gray-700 border-gray-200',
      iconColor: 'text-gray-500',
      barColor: 'bg-gray-300',
    },
  } satisfies Record<IssueStatus, StatusConfig>;

  return (
    statusConfig[status] ?? {
      icon: Circle,
      label: status || t('statusUnknown'),
      className: 'bg-gray-50 text-gray-700 border-gray-200',
      iconColor: 'text-gray-500',
      barColor: 'bg-gray-300',
    }
  );
};
